var htmlContent = "";

if (document.getElementById("shopify-section-template--23428329275737__a328123a-4bd3-4ce4-9e30-2758213c49f6") && document.getElementById("shopify-section-template--23428329275737__34588b6e-22a9-40df-849c-7f2180a65343")) {

var wappObj = document.getElementById("shopify-section-template--23428329275737__a328123a-4bd3-4ce4-9e30-2758213c49f6");
var newsletterObj = document.getElementById("shopify-section-template--23428329275737__34588b6e-22a9-40df-849c-7f2180a65343");

htmlContent = document.getElementById("shopify-section-template--23428329275737__a328123a-4bd3-4ce4-9e30-2758213c49f6").outerHTML;          
htmlContent += document.getElementById("shopify-section-template--23428329275737__34588b6e-22a9-40df-849c-7f2180a65343").outerHTML;          

wappObj.remove();
newsletterObj.remove();

var gridObj = document.getElementById("group-grid-wapp-news").innerHTML = htmlContent;
}


$(document).ready(function(){
    
    let toDate = new Date(); // Oggi
    toDate.setDate(toDate.getDate() + 4); // Aggiunta di 4 giorni (2 di gestione + 2 di consegna)


    // se è sabato o domenica salto al lunedì
    if (toDate.getDay() == 6) {
        toDate.setDate(toDate.getDate() + 2); // Aggiunta di 2 giorni per arrivare al lunedì successivo
    }
    if (toDate.getDay() == 0) {
        toDate.setDate(toDate.getDate() + 1); // Aggiunta di 2 giorni per arrivare al lunedì successivo
    }
  
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    var ToDateString = toDate.toLocaleDateString('it-it',options);
  
         
    //if ($("#fromDate").length > 0 && $("#toDate").length > 0) {
    if ( $("#toDate").length > 0) {
      //document.getElementById('fromDate').innerHTML = FromDateString;
      document.getElementById('toDate').innerHTML = ToDateString;
    }

  if ( $("#toDateCart").length > 0) {
      //document.getElementById('fromDate').innerHTML = FromDateString;
      document.getElementById('toDateCart').innerHTML = ToDateString;
    }
});



